import React, { useEffect, useState } from "react";
import instance from "../../services/axiosInstane";
import { AssessmentProps } from "../../interfaces/Interface";
import { messages } from "../../config/messages";
import { snackbarColor } from "../../config/constants";
import DataTable from "../../components/DataTable/DataTable";
import Header from "../../components/Header/Header";
import { totalPages } from "../../helpers/helpers";
import Pagination from "../../components/Pagination/Pagination";
import SearchInput from "../../components/Input/SearchInput";
import Loader from "../../components/Loader/Loader";
import SnackBar from "../../components/SnackBar/SnackBar";

type RequestProps = {
  Page: number;
  PageSize: number;
  SearchText: string;
  SortBy: string;
  SortOrder: string;
  StartDate: Date | null | string;
  EndDate: Date | null | string;
};
const columns = [
  { id: "email", label: "Email", width: 150 },
  { id: "firstName", label: "First Name", width: 150 },
  { id: "lastName", label: "Last Name", width: 150 },
  { id: "phone", label: "Phone", width: 150 },
  { id: "createdDate", label: "Created Date", width: 150 },
  { id: "viewDetails", label: "View Details", width: 150 },
];
const UsersReport = () => {
  const [reportResponse, setReportResponse] = useState<AssessmentProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState({
    value: false,
    message: "",
    type: "",
  });
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [requestReport, setRequestReport] = useState<RequestProps>({
    Page: page,
    PageSize: limit,
    SearchText: "",
    SortBy: "",
    SortOrder: "DESC",
    StartDate: null,
    EndDate: null,
  });

  useEffect(() => {
    getUserReport(requestReport);
  }, []);

  const getUserReport = async (obj: RequestProps) => {
    setIsLoading(true);
    await instance
      .get(`/report/user-apps`, { params: obj })
      .then((response) => {
        setReportResponse(response?.data.results);
        setTotalRowCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "error");
        setSnackBarOpen({
          ...snackBarOpen,
          value: true,
          message: messages.somethingWentWrong,
          type: snackbarColor.error,
        });
        setIsLoading(false);
      });
  };
  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getUserReport({ ...requestReport, Page: page, PageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getUserReport({
          ...requestReport,
          Page: page + 1,
          PageSize: limit,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getUserReport({
          ...requestReport,
          Page: page - 1,
          PageSize: limit,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getUserReport({
          ...requestReport,
          Page: 1,
          PageSize: limit,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getUserReport({
          ...requestReport,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getUserReport({
        ...requestReport,
        Page: 1,
        PageSize: item,
      });
      setLimit(item);
      setPage(1);
    },
  };
  const searchHandler = () => {
    getUserReport({
      ...requestReport,
      Page: 1,
      PageSize: limit,
      SearchText: requestReport.SearchText,
    });
  };
  const filterHandler = () => {
    const start = new Date(requestReport.StartDate as Date);
    const end = new Date(requestReport.EndDate as Date);

    if (
      end > start ||
      requestReport.StartDate === null ||
      requestReport.EndDate === null
    ) {
      getUserReport({
        ...requestReport,
        Page: 1,
        PageSize: limit,
        SearchText: requestReport.SearchText,
        StartDate:
          requestReport.StartDate !== null
            ? `${requestReport.StartDate}T00:00:00.000Z`
            : requestReport.StartDate,
        EndDate:
          requestReport.EndDate !== null
            ? `${requestReport.EndDate}T23:59:59.000Z`
            : requestReport.EndDate,
      });
      // T23:59:59.000Z
    } else {
      setSnackBarOpen({
        ...snackBarOpen,
        value: true,
        message: messages.dateErr,
        type: snackbarColor.error,
      });
    }
  };

  const onClearSearch = () => {
    setRequestReport({ ...requestReport, SearchText: "" });
    getUserReport({
      ...requestReport,
      Page: 1,
      PageSize: limit,
      SearchText: "",
    });
  };
  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      searchHandler();
    }
  };
  return (
    <main className="p-6 bg-slate-100 border w-full shadow-lg min-h-screen">
      {isLoading ? <Loader /> : null}
      <div className="mb-6">
        <Header />
      </div>

      <div>
        <div className=" text-gray-500 text-lg w-full bg-white p-2 rounded-sm mb-2 shadow-md  ">
          <div className="text-xl font-semibold text-blue-800 mb-4 pl-2 border-b-2 pb-1 border-blue-800 mx-2">
            User information
          </div>
          <div className="xl:flex justify-between items-center px-2">
            <div className="md:w-fit w-full flex items-center mb-2 ">
              <SearchInput
                label={"Search"}
                type="text"
                placeholder="Search email or name etc"
                value={requestReport.SearchText}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setRequestReport({
                    ...requestReport,
                    SearchText: e.target.value,
                  })
                }
                onClearSearch={onClearSearch}
                showClear={true}
                handleEnterKeyPress={handleEnterKeyPress}
              />
              <div
                onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                  if (event.key === "Enter" || event.code == "Space") {
                    searchHandler();
                  }
                }}
                tabIndex={0}
                onClick={searchHandler}
                className="bg-blue-400 mt-3 md:mt-5 h-8 w-8 text-center flex items-center justify-center cursor-pointer"
              >
                <i className="fa-solid fa-magnifying-glass text-white"></i>
              </div>
            </div>
            <div className="md:flex md:space-x-2 mb-2">
              <SearchInput
                label={"Start Date"}
                type="date"
                placeholder="Search email or name etc"
                value={requestReport.StartDate}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setRequestReport({
                    ...requestReport,
                    StartDate: e.target.value,
                  })
                }
              />
              <SearchInput
                label={"End Date"}
                type="date"
                placeholder="Search email or name etc"
                value={requestReport.EndDate}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setRequestReport({
                    ...requestReport,
                    EndDate: e.target.value,
                  })
                }
              />
              <div
                onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                  if (event.key === "Enter" || event.code == "Space") {
                    filterHandler();
                  }
                }}
                tabIndex={0}
                onClick={filterHandler}
                className="bg-blue-400 mt-5 h-8 w-8 text-center flex items-center justify-center cursor-pointer rounded-sm"
              >
                <i className="fa-solid fa-filter text-white"></i>
              </div>
            </div>
          </div>
        </div>
        <DataTable columns={columns} rowData={reportResponse} />
        {totalRowCount > 20 && (
          <div className="m-4">
            <Pagination
              page={page}
              limit={limit}
              paginateHandler={paginateHandler}
              totalRowCount={totalRowCount}
            />
          </div>
        )}
      </div>
      <SnackBar
        isOpen={snackBarOpen.value}
        handleClose={() => setSnackBarOpen({ ...snackBarOpen, value: false })}
        message={snackBarOpen.message}
        type={snackBarOpen.type}
      />
    </main>
  );
};

export default UsersReport;
